// extracted by mini-css-extract-plugin
export default {"searchRow":"VideoList_searchRow__B74UF","search":"VideoList_search__24kX6","trem":"VideoList_trem__zrKdy","kcxx":"VideoList_kcxx__nGawW","select":"VideoList_select__lCv98"};